import Cookies from 'js-cookie';

jQuery(document).ready(function () {
   initHeaderSticky();
   $(window).on('scroll resize', function () {initHeaderSticky();});
   initMobileNav();
   initAnimateSocialIcons();
   initBlogFilter();
   initListAnimations();
   $(window).on("scroll", initAnimateTrigger);
   $(window).on("scroll", initRevealContent);
   initGoogleMapsView();
   initBannerWithCookie();
   initBrandsShowMore();
});

function initHeaderSticky() {
   const wrapper = $('.fixed-header');
   const topHeader = $('.top-header');
   const siteHeader = $('.site-header');

   // Return early if elements don't exist to avoid console errors
   if (!topHeader.length || !siteHeader.length) return;

   const windowWidth = $(window).width();
   const scrollPos = $(window).scrollTop();

   if (windowWidth < 1400) {
      const topBarHeight = topHeader.outerHeight();

      if (scrollPos >= topBarHeight) {
         siteHeader.addClass('is-sticky');
         // Prevent content jump by adding padding to the parent wrapper
         wrapper.css('padding-top', siteHeader.outerHeight() + 'px');
      } else {
         siteHeader.removeClass('is-sticky');
         wrapper.css('padding-top', '0');
      }
   } else {
      // Clear mobile-specific sticky styles when on desktop
      siteHeader.removeClass('is-sticky');
      wrapper.css('padding-top', '0');
   }
}

function initMobileNav() {

   $('.burger-menu').on('click', function (e) {
      e.preventDefault();
      $('.mobile-nav-container').addClass('active');
   });

   $('.nav-close').on('click', function (e) {
      e.preventDefault();
      $('.mobile-nav-container').removeClass('active');
   });

}

function initAnimateSocialIcons() {
   // Target only the direct, top-level main buttons inside the wrap
   $('.inner-fixed-wrap > .sha-icon').each(function (index) {
      const icon = $(this);

      setTimeout(() => {
         icon.addClass('animate-social-icons');
      }, index * 200);
   });
}

function initBlogFilter() {
   // Filter button click handler
   $('#blog-filters .filter-btn').on('click', function () {
      const $this = $(this); // Cache jQuery object
      const category = $this.data('category');

      $('.filter-btn').removeClass('active');
      $this.addClass('active');

      $.ajax({
         url: ajax.url,
         type: 'POST',
         data: {action: 'filter_posts', category: category, page: 1},
         beforeSend: function () {
            $('#blog-response').css('opacity', '0.5');
         },
         success: function (data) {
            const $response = $('#blog-response');
            $response.html(data)
               .attr('data-page', 1)
               .attr('data-category', category)
               .css('opacity', '1');

            if ($(data).filter('#last-page-reached').length > 0) {
               $('#load-more').hide();
            } else {
               $('#load-more').show().text('Weitere Beiträge laden');
            }
         }
      });
   });

   // Load more click handler
   $('#load-more').on('click', function () {
      const $button = $(this);
      const $container = $('#blog-response');
      const page = parseInt($container.attr('data-page')) + 1;
      const category = $container.attr('data-category');

      $button.text('Laden...');

      $.ajax({
         url: ajax.url,
         type: 'POST',
         data: {action: 'filter_posts', category: category, page: page},
         success: function (data) {
            if (data.trim().length > 0) {
               $container.append(data);
               $container.attr('data-page', page);
               $button.text('Weitere Beiträge laden');

               if ($(data).filter('#last-page-reached').length > 0) {
                  $button.hide();
               }
            } else {
               $button.hide();
            }
         }
      });
   });

   // Search functionality
   $('#blog-search').on('keyup', function () {
      const value = $(this).val().toLowerCase();

      $('.blog-card').filter(function () {
         const matches = $(this).text().toLowerCase().indexOf(value) > -1;
         $(this).toggle(matches);
      });
   });
}

function initListAnimations() {
   const wrapper = $('.wp-block-list');

   if (wrapper.length) {
      wrapper.addClass('animation-wrapper');

      // 2. Find all li items within that wrapper
      wrapper.find('li').each(function (index) {
         const item = $(this);

         // Add the item class
         item.addClass('animation-item');

         // Optional: Trigger a staggered entrance (like your social icons)
         setTimeout(function () {
            item.addClass('is-visible');
         }, index * 100); // 100ms delay between each item
      });
   }
}

function initAnimateTrigger() {
   $(".animation-wrapper").each(function () {
      const currentWrapper = $(this);

      if (currentWrapper.hasClass("animated")) return;

      const windowBottom = $(window).scrollTop() + $(window).height();
      const wrapperTop = currentWrapper.offset().top;

      if (windowBottom > wrapperTop + 50) {
         currentWrapper.addClass("animated");

         currentWrapper.find(".animation-item").each(function (index) {
            const item = $(this);
            setTimeout(() => {
               item.addClass("visible");
            }, index * 400); // 0.4s stagger
         });
      }
   });
}

function initRevealContent() {
   let reveals = $(".reveal");
   let offset = -40; // How far from the bottom the element triggers
   let windowHeight = window.innerHeight;

   reveals.each(function () {
      let elementTop = this.getBoundingClientRect().top;

      // Trigger if the element enters the viewport
      if (elementTop < windowHeight + offset) {
         $(this).addClass("active");
      }
   });
}

function initGoogleMapsView() {
   const container = $('#google-maps-container');
   const trigger = $('#load-maps-trigger');

   if (trigger.length && container.length) {

      trigger.on('click', function (e) {
         e.preventDefault();
         container.addClass('is-active');
      });
   }
}

function initBannerWithCookie() {
   const banner = $('#js-sticky-banner');
   const closeBtn = $('#js-close-banner');
   const cookieName = 'hide_notification_banner';

   if (!banner.length) return;

   // 1. Check if the cookie is NOT set
   if (Cookies.get(cookieName) !== 'true') {
      banner.show();
   } else {
      // If cookie exists, ensure it stays removed from DOM
      banner.remove();
      return;
   }

   // 2. Click handler to close
   if (closeBtn.length) {
      closeBtn.on('click', function (e) {
         e.preventDefault();

         // Fade out effect
         banner.css('opacity', '0');

         // Set cookie
         Cookies.set(cookieName, 'true', {expires: 1, path: '/'});

         // Remove after transition
         setTimeout(function () {
            banner.addClass('is-hidden');
            banner.remove();
         }, 400);
      });
   }
}




function initBrandsShowMore() {

   let step = 12;
   let visible = step;

   let $items = $('.brand-item');
   let $button = $('#show-more-brands');

   // if no items, stop
   if ($items.length === 0) return;

   // initial state: show first 12
   $items.slice(0, visible).removeClass('brand-hidden');

   // click handler
   $button.on('click', function (e) {
      e.preventDefault();

      visible += step;

      $items.slice(0, visible).removeClass('brand-hidden');

      // hide button when done
      if (visible >= $items.length) {
         $button.hide();
      }
   });
}

